/*=========================================================================================
  File Name: module-customsdeclaration-mutations.js
  Description: CustomsDeclaration Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: DQDUY
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */
import { MSEnum } from '@/common/enumeration';
import msDateUtil from '@/components/msdatepicker/msDateUtil';
import defaultState from './module-customsdeclaration-state';

export default {
	resetState(state) {
		Object.assign(state, defaultState);
	},
	updateCustomsDeclaration(state, res) {
		let result = res.data;
		state.CustomsDeclaration = result.Data || [];
		if (res.isGetTotal) {
			// API có lấy ds hóa đơn có lấy thông tin tổng hóa đơn
			state.CustomsDeclarationTotal = result.Total;
		} else if (result.Total) {
			state.CustomsDeclarationTotal = result.Total ? result.Total : state.CustomsDeclarationTotal;
		}
	},
	updateLoadingTotalRecords(state, res) {
		state.IsLoadingTotalRecords = res;
	},
	updateTotalPage(state, res) {
		state.CustomsDeclarationTotal = res || 0;
	},
	/**
	 * Cập nhật danh sách tờ khai được chọn
	 * @param {Object} state - Vuex state
	 * @param {Array} declarations - Danh sách tờ khai được chọn
	 * @author dqduy 09.02.2026
	 */
	updateSelectedDeclarations(state, declarations) {
		state.selectedDeclarations = declarations || [];
	},
	/**
	 * Xóa toàn bộ selection
	 * @param {Object} state - Vuex state
	 * @author dqduy 09.02.2026
	 */
	clearSelectedDeclarations(state) {
		state.selectedDeclarations = [];
	}
};
